import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./HomeSwiper.css";
// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";
export default function HomeSwiper({sildeimgs}) {
  return (
    <>
      <div className=" xl:w-3/5 w-4/5">
        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          draggable = {true}
          pagination={{
            el: ".custom-pagination",
            clickable: true,
            renderBullet: (index, className) => {
              return `<span class="${className} custom-bullet"></span>`;
            },
          }}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
        >
          {sildeimgs.map((img, index) => (
            <SwiperSlide key={index} className="">
              <img src={img.src} alt={img.alt} className="rounded-2xl  cursor-grab object-cover" />
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom pagination container */}
        <div className="custom-pagination flex justify-center gap-3 mt-16"></div>
      </div>
    </>
  );
}
